import { useIsAdminUser } from '@app/core/auth/authentication/hooks/useIsAdminUser';
import { useImpersonation } from './useImpersonationStore';

/** Returns true when the admin account is acting as another user (tab override or persisted). */
export function useIsImpersonationOn() {
  const isAdminUser = useIsAdminUser();
  const { authAsUserId } = useImpersonation();

  return isAdminUser && !!authAsUserId;
}
